/*
 * The designation Go Colors sees for a selected candidate - in the Salary & Onboarding
 * modal, the Salary Details badge and the Designation column of the ZIP Excel export.
 * All three read from here so the screen and the file can never disagree.
 *
 * The overrides are the client's own mapping sheet: their payroll system wants its
 * spelling ("Customer Service Executive - EBO"), not our job-post title
 * ("Customer Sales Executive (CSE)"). Any title not listed falls back to
 * "<storeFormat> - <title>".
 */

const STORE_FORMATS = ['EBO', 'LFS'];
const DEFAULT_STORE_FORMAT = 'EBO';

// Keys are designationKey() output, so case, spacing, a "(CSE)"-style abbreviation and an
// existing "EBO - " prefix don't matter. Scoped per format so an LFS job titled
// "Store Manager" never picks up an EBO designation.
const DESIGNATION_OVERRIDES = {
  EBO: {
    'customer sales executive': 'Customer Service Executive - EBO',
    'senior customer executive': 'Sr.Customer Service Executive - EBO',
    supervisor: 'Supervisor - EBO',
    'assistant store manager': 'Assistant Store Manager - EBO',
    'store manager': 'Store Manager - EBO',
    'senior store manager': 'Sr.Store Manager - EBO',
  },
  LFS: {
    'brand executive - reliance': 'Brand Executive - Reliance Retail',
  },
};

const FORMAT_PREFIX = /^\s*(?:EBO|LFS)\s*-\s*/i;

function designationKey(title) {
  return title
    .replace(FORMAT_PREFIX, '')
    .replace(/\([^)]*\)/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function toStoreFormat(storeFormat) {
  const format = String(storeFormat || '').toUpperCase();
  return STORE_FORMATS.includes(format) ? format : DEFAULT_STORE_FORMAT;
}

// Older salary requests stored the literal string 'undefined' when the HRBP left it blank.
function cleanTitle(value) {
  const text = typeof value === 'string' ? value.trim() : '';
  return text === 'undefined' ? '' : text;
}

/**
 * Format one title for display/export. Returns '' when there is no title.
 */
export function formatGoColorsDesignation(title, storeFormat) {
  const raw = cleanTitle(title);
  if (!raw) return '';

  const format = toStoreFormat(storeFormat);
  const override = DESIGNATION_OVERRIDES[format][designationKey(raw)];
  if (override) return override;

  return FORMAT_PREFIX.test(raw) ? raw : `${format} - ${raw}`;
}

/**
 * The designation for a candidate: what the HRBP entered on the salary form, otherwise the
 * job-post title, formatted for the screening's store format.
 */
export function resolveGoColorsDesignation(salaryData, screeningMeta) {
  return formatGoColorsDesignation(
    cleanTitle(salaryData?.designation) || screeningMeta?.jobTitle,
    screeningMeta?.storeFormat
  );
}
